import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => {
  const { primary } = theme.palette;

  return {
    header: {
      display: "flex",
      justifyContent: "flex-end",
      alignSelf: "center",
      padding: "0 24px",
      borderBottom: `1px solid ${primary.light}`,
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        padding: "0 16px"
      }
    },
    examFormHeader: {
      paddingRight: 16,
      transition: "padding .5s",
      justifyContent: "space-between",
      width: "100%",
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        borderBottom: `1px solid #eee`,
        transition: "none",
        paddingRight: 2,
        position: "fixed",
        width: "100%",
        backgroundColor: "#fff",
        zIndex: 2
      },
      "&.hideRightPanel": {
        padding: "0 70px 0 24px"
      }
    },
    leftSide: {
      display: "flex",
      alignItems: "center"
    },
    horseData: {
      padding: "4px 0",
      marginLeft: 12
    },
    primaryHorseInfo: {
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      fontSize: 18,
      color: primary.main
    },
    secondaryHorseInfo: {
      fontSize: 12,
      color: primary.main,
      wordBreak: "break-all"
    },
    infoButton: {
      color: primary.main
    },
    resetButton: {
      height: 45,
      alignSelf: "center",
      color: primary.dark,
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        height: 42
      }
    }
  };
});
